'use client'

import { useQuery } from '@tanstack/react-query'
import { isNull } from 'lodash-es'
import { useMemo } from 'react'

import { contractQueries } from '@/entities/contract'

type Props = {
  contractId: number
}

export const useRefundAccount = ({ contractId }: Props) => {
  const { data } = useQuery({
    ...contractQueries.guestRefundAccount({
      contractId,
    }),
    enabled: false,
    meta: {
      useCustomHandling: true,
    },
  })

  const refundAccount = useMemo(() => {
    if (!data?.refundBankAccount) {
      return '계좌 정보 없음'
    }

    return `${data?.refundBankName} ${data?.refundBankAccount} (${data?.refundBankHolder})`
  }, [data])

  const isRefunded = data?.isRefunded && !isNull(data?.refundedAt)

  return {
    isRefunded,
    refundAccount,
    refundedAt: data?.refundedAt ?? null,
  }
}
